export function addCurrent(integrationUserVariable) {
  return {
    type: 'ADD_CURRENT',
    integrationUserVariable,
  }
}
